import deTranslations from './de.json';
import enTranslations from './en.json';
import esTranslations from './es.json';
import frTranslations from './fr.json';
import hiTranslations from './hi.json';
import itTranslations from './it.json';
import jaTranslations from './ja.json';
import koTranslations from './ko.json';
import nlTranslations from './nl.json';
import ptTranslations from './pt.json';
import ruTranslations from './ru.json';
import trTranslations from './tr.json';

export {
  deTranslations,
  enTranslations,
  esTranslations,
  frTranslations,
  hiTranslations,
  itTranslations,
  jaTranslations,
  koTranslations,
  nlTranslations,
  ptTranslations,
  ruTranslations,
  trTranslations,
};
